import config from 'react-global-configuration';
import { setOperationStatus, UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_SUCCESS, userGetCurrent } from '@uncinc/react-drupal-core';

export const createOrUpdateUserProfile = (values) => {
  return (dispatch, getState) => {
    dispatch(setOperationStatus('profile', 'update', UI_OPERATION_STATUS_REQUEST));

    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    const uid = getState().getIn(['login', 'uid']);
    const profileId = getState().getIn(['user', uid, 'profile', 'profile_id', 0, 'value']);
    if (!uid) {
      dispatch(setOperationStatus('profile', 'update', UI_OPERATION_STATUS_ERROR));
      return;
    }

    fetch(`${API_URL}/rest/session/token`, { credentials: 'include' })
      .then((csrfResponse) => csrfResponse.text())
      .then((csrfResponse) => {
        const csrfToken = csrfResponse;
        let method = 'POST';
        let url = `${PATH}/entity/profile?_format=json`;

        if (profileId) {
          method = 'PATCH';
          url = `${PATH}/profile/${profileId}?_format=json`;
        }

        const body = {
          type: 'customer',
          ...values,
        };

        fetch(url, {
          method: method,
          credentials: 'include',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        })
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              throw new Error(response.status);
            }
            return response.json();
          })
          .then((response) => {
            dispatch(userGetCurrent());
            dispatch(setOperationStatus('profile', 'update', UI_OPERATION_STATUS_SUCCESS));
          })
          .catch(() => {
            dispatch(setOperationStatus('profile', 'update', UI_OPERATION_STATUS_ERROR));
          });
      })
      .catch(() => {
        dispatch(setOperationStatus('profile', 'update', UI_OPERATION_STATUS_ERROR));
      });
  };
};
